import { History } from 'history';
import * as React from 'react';

export const HistoryContext = React.createContext({} as History);
